import { NavLink } from "react-router-dom"
import HomeWidgetLayout from "components/layout/HomeWidgetLayout"
import { CanSendAbsenceRequest } from "../../../../app/PermissionChecker"
import { useTranslation } from "react-i18next"

function SeeMyAbsenceWidget() {

    const [t, i18n] = useTranslation(["absenceReport"])

    return <HomeWidgetLayout
        title={t("absenceReport:module.short_name")}
        permission={CanSendAbsenceRequest}
        content={<>
            <p className="text-muted"><i className="fa-regular fa-calendar-check fa-2xl"></i></p>
            <p>{t("absenceReport:helper.see_your_requests")}</p>

            <button className="btn btn-primary " type="button">
                <NavLink to={{ pathname: "/dashboard/absences/my" }} className="nav-link"><i className="fa-solid fa-calendar-check"></i> {t("absenceReport:menu.my_absences")}</NavLink>
            </button>

        </>}
    />
}

export default SeeMyAbsenceWidget